import React from 'react';
import styles from '../../../../styles/automationStudio/automationStudio.module.scss';

const formatDuration = (ms) => {
    if (!ms && ms !== 0) return '0ms';
    if (ms < 1000) return `${Math.round(ms)}ms`;
    return `${(ms / 1000).toFixed(1)}s`;
};

function resolveOutcome(statusText) {
    const s = String(statusText ?? '').trim();
    if (/^(passed|success)$/i.test(s)) return 'pass';
    if (/^(failed|failure)$/i.test(s)) return 'fail';
    return 'neutral';
}

export default function AIEvaluationBlock({ reason, statusText, confidence, stepDuration }) {
    if (!reason) return null;

    const outcome = resolveOutcome(statusText);
    const isPass = outcome === 'pass';
    const isFail = outcome === 'fail';

    const blockClass = [
        styles.aiEvalReplayBlock,
        isPass ? styles.aiEvalReplayBlockPass : isFail ? styles.aiEvalReplayBlockFail : styles.aiEvalReplayBlockNeutral,
    ].join(' ');

    const titleClass =
        outcome === 'neutral'
            ? `${styles.aiEvalReplayTitle} ${styles.aiEvalReplayTitleNeutral}`
            : styles.aiEvalReplayTitle;

    const bodyClass = [styles.aiEvalReplayBody, isFail ? styles.aiEvalReplayBodyFail : '']
        .filter(Boolean)
        .join(' ');

    const normConf = confidence != null ? (confidence <= 1 ? confidence * 100 : confidence) : null;
    const isHighConf = normConf != null && normConf >= 85;
    const isMedConf = normConf != null && normConf >= 50 && normConf < 85;
    const confLabel = normConf == null ? null : isHighConf ? 'High confidence' : isMedConf ? 'Medium confidence' : 'Low confidence';

    let confInline = {};
    if (confLabel) {
        if (isPass) {
            confInline = isHighConf
                ? { backgroundColor: '#ecfdf5', color: '#166534', border: '1px solid #86efac' }
                : isMedConf
                  ? { backgroundColor: '#fffbeb', color: '#854d0e', border: '1px solid #fde68a' }
                  : { backgroundColor: '#f8fafc', color: '#64748b', border: '1px solid #e2e8f0' };
        } else if (isFail) {
            confInline = isHighConf
                ? { backgroundColor: '#fef2f2', color: '#991b1b', border: '1px solid #fecaca' }
                : isMedConf
                  ? { backgroundColor: '#fff7ed', color: '#9a3412', border: '1px solid #fed7aa' }
                  : { backgroundColor: '#f8fafc', color: '#64748b', border: '1px solid #e2e8f0' };
        } else {
            confInline = isHighConf
                ? { backgroundColor: '#f1f5f9', color: '#334155', border: '1px solid #e2e8f0' }
                : isMedConf
                  ? { backgroundColor: '#fffbeb', color: '#854d0e', border: '1px solid #fde68a' }
                  : { backgroundColor: '#f8fafc', color: '#64748b', border: '1px solid #e2e8f0' };
        }
    }

    return (
        <div className={blockClass}>
            <div className={styles.aiEvalReplayHeader}>
                <span className={titleClass}>AI Evaluation</span>
                {confLabel && (
                    <span className={styles.aiEvalReplayConfBadge} style={confInline}>
                        {confLabel}
                    </span>
                )}
            </div>
            <p className={bodyClass}>{reason}</p>
            {stepDuration != null && (
                <span className={styles.aiEvalReplayDuration}>
                    AI evaluation took: {formatDuration(stepDuration)}
                </span>
            )}
        </div>
    );
}
